export default {
  subtitle: "Mexican Bank Accounts",
  path: "bank_accounts_mxn",
  paragraphs: [
    "Your Mexican Bank Account will be available within your credentials and your Portal. You can always check it in Bank Accounts > FacilitaPay Payin accounts.",
    "To add your customer's bank account in Mexico, use the endpoint below. Replace :id with the subject_id:"
  ],
  request:  {
    method: "POST",
    endpoint: "/subject/:id/bank_accounts",
    payload: {
      "bank_account": {
        "bank": {
          "name": "IXE Banco, S.A",
          "code": "032"
        },
        "account_number": "032180000118359719",
        "account_type": "conta-corrente",
        "owner_name": "Horacio Soto Morales",
        "currency": "MXN",
        "owner_document_type": "curp",
        "owner_document_number": "SOMH031031HSRTRR04"
      }
    },
    responses:{
      "data": {
        "routing_number": null,
        "pix_info": null,
        "owner_name": "Horacio Soto Morales",
        "owner_document_number": "MIML92Y0DAD86",
        "owner_document_type": "curp",
        "owner_company": {
          "social_name": "Horacio Soto Morales",
          "id": "ac3bf8d8-e299-4fe9-8565-2ff6fe7c2dec",
          "document_type": "curp",
          "document_number": "SOMH031031HSRTRR04"
        },
        "nickname": null,
        "intermediary_bank_account": null,
        "id": "516f4dcb-673a-4687-91a4-98bb52a4983a",
        "iban": null,
        "currency": "MXN",
        "branch_number": null,
        "branch_country": null,
        "bank": {
          "swift": null,
          "name": "IXE Banco, S.A",
          "id": "784fa04b-923a-429e-baee-d96298431dc0",
          "country": "MEX",
          "code": "032",
          "ispb": null,
        },
        "account_type": "conta-corrente",
        "account_number": "032180000118359719",
        "aba": null
      }
    }
  },

  parameterPayload: [
    {
      name: "bank_account",
      type: "object",
      required: true,
      description: "An object containing:",
      is_parent: true
    },
    {
      name: "bank_account.account_number",
      type: "string",
      required: true,
      description: "Account CLABE",
    },
    {
      name: "bank_account.account_type",
      type: "string",
      required: true,
      description: "Account type in Mexico, they will be mapped as follows: Conta Corriente -> 'conta-corrente'; Cuenta de Ahorros -> 'poupanca'",
    },
    {
      name: "bank_account.currency",
      type: "string",
      required: true,
      description: "Account currency (ISO 4217 format)",
    },
    {
      name: "bank_account.bank",
      type: "object",
      required: true,
      description: "An object containing information from the bank which the account belongs:",
      is_parent: true
    },
    {
      name: "bank_account.bank.name",
      type: "string",
      required: true,
      description: "Bank name",
    },
    {
      name: "bank_account.bank.code",
      type: "string",
      required: true,
      description: "Bank Code",
    },
    {
      name: "bank_account.owner_document_type",
      type: "string",
      required: false,
      description: "curp or rfc (downcase)",
    },
    {
      name: "bank_account.owner_document_number",
      type: "string",
      required: false,
      description: "Account owner document number CURP/RFC",
    },
    {
      name: "bank_account.owner_name",
      type: "string",
      required: false,
      description: "Account owner full name",
    },
    {
      name: "bank_account.branch_country",
      type: "String",
      required: false,
      description: "An ISO 3166-1 alpha-3 country code of the account country. For Mexico, use 'MEX'.",
    }
  ],
  footerNotes: "If a previously registered bank code is provided, its corresponding name will be overwritten with the recorded in our database.",
  troubleshooting: {
    title: 'Common mistakes',
    messages: [
      {
        description: 'Not providing currency',
        code: {
            "errors": {
                "currency": [
                    "can't be blank"
                ]
            }
        },
        solution: 'Provide a valid currency, in this case MXN'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/BankAccount/BankAccountsRegistrationMXN.js